export default function SVG_Ellipse() {
  return (
    <div>
      <h1>SVG_Ellipse Component</h1>
    </div>
  );
}
